import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/shared/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirm-password',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.sass']
})
export class ConfirmPasswordComponent implements OnInit {
  slideConfig2 = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0",
    slidesToShow: 1,
    speed: 500,
    dots: true,
  };

  email: string;
  mailsent: boolean = false;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private toasterService: ToastrService
  ) {}

  token: string;
  activationDetails: any;
  loading: boolean = false;
  invalidToken:boolean=false;
  errorMessage:string;
  ngOnInit() {
    this.route.params.subscribe((params) => {
      console.log(params.code);
      this.token = params.code;
      this.loading = true;
      this.authService.verifyResetToken(params.code).subscribe(
        (res) => {
          console.log(res);
          if (res.errors) {
            this.errorMessage= res?.errors[0]?.message
            ? res?.errors[0]?.message
            : "Some error occured"
            console.log("res");
            this.toasterService.error(this.errorMessage ,
              "Error",
              {
                positionClass: "toast-top-right",
              }
            );
          } else {
            this.toasterService.success(res?.msg, "Success", {
              positionClass: "toast-top-right",
            });
            this.activationDetails = res;
          }
          this.loading = false;
        },
        (err) => {
          console.log("Some error occured");
          this.errorMessage=  err?.errors[0]?.message
          ? err?.errors[0]?.message
          : "Some error occured"
          console.log("res");
          this.toasterService.error(this.errorMessage ,
            "Error",
            {
              positionClass: "toast-top-right",
            }
          );
          this.loading = false;
          this.invalidToken=true;
        }
      );
    });
  }
  password: string = "";
  cpassword: string = "";

  activatePassword() {
    //call the recover password service
    if (this.password.length < 6 || this.password.length >= 40) {
      this.toasterService.error(
        "The Password must have with in 6-40 characters",
        "Error",
        {
          positionClass: "toast-top-right",
        }
      );
    } else if (this.password != this.cpassword) {
      this.toasterService.error("Passwords doesnt match!", "Error", {
        positionClass: "toast-top-right",
      });
    } else {
      this.loading = true;
      this.authService.resetPassword(this.password, this.token).subscribe(
        (res) => {
          if (res.errors) {
            console.log("res");
            this.toasterService.error(
              res?.errors[0]?.message
                ? res?.errors[0]?.message
                : "Some error occured",
              "Error",
              {
                positionClass: "toast-top-right",
              }
            );
          } else {
            this.toasterService.success(res?.msg, "Success", {
              positionClass: "toast-top-right",
            });
            this.mailsent = true;
          }
          this.loading = false;
        },
        (err) => {
          console.log("Some error occured");
          this.toasterService.error(
            err?.errors[0]?.message
              ? err?.errors[0]?.message
              : "Some error occured",
            "Error",
            {
              positionClass: "toast-top-right",
            }
          );
          this.loading = false;
        }
      );
    }
  }

}
